$(document).ready(function() { 
    function adjustSearchBar() {
        var windowWidth = $(window).width();
        if (windowWidth < 768) {
            $(".cus_mobile_searchbar").css("display", "block");
            $(".cus_desktop_searchbar").css("display", "none");
        } else {
            $(".cus_mobile_searchbar").css("display", "none");
            $(".cus_desktop_searchbar").css("display", "block");
        }
    }
    adjustSearchBar();
    $(window).resize(function() {
        adjustSearchBar();
    });
});